// Relationship options for a list a parent/guardian/caregiver adds on behalf of
// someone else. Shared by NamesList's Add-list dropdown/Chip and ClaimedItems'
// "(relationship of member)" recipient labels.

export const RELATIONSHIP_OPTIONS = [
  { value: "child", label: "Child" },
  { value: "step_child", label: "Step-Child" },
  { value: "grandchild", label: "Grandchild" },
  { value: "elderly_parent", label: "Elderly Parent" },
  { value: "spouse_partner", label: "Spouse/Partner" },
  { value: "other", label: "Other" },
];

export const RELATIONSHIP_LABELS = Object.fromEntries(
  RELATIONSHIP_OPTIONS.map((o) => [o.value, o.label])
);

// Rows created before relationship_label existed (is_child_list = true, no
// relationship_label) still need something to display.
export const DEFAULT_RELATIONSHIP_LABEL = "Child";

// Resolves the label to actually display for a names row: the user's typed
// text for "Other", the matching fixed option otherwise, or the legacy
// fallback for pre-migration rows that have neither.
export function getRelationshipDisplayLabel(row) {
  if (row?.relationship_label === "other" && row?.relationship_custom_label) {
    return row.relationship_custom_label;
  }
  return RELATIONSHIP_LABELS[row?.relationship_label] || DEFAULT_RELATIONSHIP_LABEL;
}
